"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Core Banking Services
 * API core - Cassa di risparmio di Bolzano
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReinforcedRecognitionControllerApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class ReinforcedRecognitionControllerApi extends runtime.BaseAPI {
    /**
     * Endpoint per restituire il button cie
     */
    buttonCieRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/cie/button`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ButtonDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint per restituire il button cie
     */
    buttonCie() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.buttonCieRaw();
            return yield response.value();
        });
    }
    /**
     * Endpoint per restituire il button spid
     */
    buttonSpidRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/spid/button`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ButtonDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint per restituire il button spid
     */
    buttonSpid() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.buttonSpidRaw();
            return yield response.value();
        });
    }
    /**
     * Endpoint che fa update dello stato in completato
     */
    campaignCompletedRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/campaign-completed`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReinforcedCampaignResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint che fa update dello stato in completato
     */
    campaignCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.campaignCompletedRaw();
            return yield response.value();
        });
    }
    /**
     * Endpoint che restitutisce true/false in base se l\'utente loggato deve fare o meno la campagna
     */
    campaignExistsRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/campaign-exists`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReinforcedCampaignResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint che restitutisce true/false in base se l\'utente loggato deve fare o meno la campagna
     */
    campaignExists() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.campaignExistsRaw();
            return yield response.value();
        });
    }
    /**
     * Crea l\'access token sumsub e associa codice cliente a session id sumsub
     */
    generateAccessTokenRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.externalScope === null || requestParameters.externalScope === undefined) {
                throw new runtime.RequiredError('externalScope', 'Required parameter requestParameters.externalScope was null or undefined when calling generateAccessToken.');
            }
            const queryParameters = {};
            if (requestParameters.externalScope !== undefined) {
                queryParameters['externalScope'] = requestParameters.externalScope;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/generate-access-token`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SumsubAccessTokenDtoFromJSON(jsonValue));
        });
    }
    /**
     * Crea l\'access token sumsub e associa codice cliente a session id sumsub
     */
    generateAccessToken(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.generateAccessTokenRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Endpoint per verificare se la dispositiva ha attivo il rafforzamento
     */
    isActiveReinforcedRecognitionRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dispositiva === null || requestParameters.dispositiva === undefined) {
                throw new runtime.RequiredError('dispositiva', 'Required parameter requestParameters.dispositiva was null or undefined when calling isActiveReinforcedRecognition.');
            }
            const queryParameters = {};
            if (requestParameters.dispositiva !== undefined) {
                queryParameters['dispositiva'] = requestParameters.dispositiva;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/is-active`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ReinforcedCampaignResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint per verificare se la dispositiva ha attivo il rafforzamento
     */
    isActiveReinforcedRecognition(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.isActiveReinforcedRecognitionRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Endpoint per restituire il link cie
     */
    linkCieRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.identityProvider === null || requestParameters.identityProvider === undefined) {
                throw new runtime.RequiredError('identityProvider', 'Required parameter requestParameters.identityProvider was null or undefined when calling linkCie.');
            }
            const queryParameters = {};
            if (requestParameters.identityProvider !== undefined) {
                queryParameters['identityProvider'] = requestParameters.identityProvider;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/cie/link`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SpidCieResponseUrlDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint per restituire il link cie
     */
    linkCie(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.linkCieRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Endpoint per restituire il link spid
     */
    linkSpidRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.identityProvider === null || requestParameters.identityProvider === undefined) {
                throw new runtime.RequiredError('identityProvider', 'Required parameter requestParameters.identityProvider was null or undefined when calling linkSpid.');
            }
            const queryParameters = {};
            if (requestParameters.identityProvider !== undefined) {
                queryParameters['identityProvider'] = requestParameters.identityProvider;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/spid/link`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.SpidCieResponseUrlDtoFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint per restituire il link spid
     */
    linkSpid(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.linkSpidRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Endpoint che restituisce lo stato della campagna
     */
    recoverCampaingStateRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/private/reinforced-recognition/recover-campaign-state`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Endpoint che restituisce lo stato della campagna
     */
    recoverCampaingState() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.recoverCampaingStateRaw();
            return yield response.value();
        });
    }
}
exports.ReinforcedRecognitionControllerApi = ReinforcedRecognitionControllerApi;
